module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/rating-header-gold.905e8074.png";